import React, { useState, useEffect } from "react";

import clsx from "clsx";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Card from "@mui/material/Card";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import LinearProgress from "@mui/material/LinearProgress";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Link, useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import { red, green } from "@mui/material/colors";
import axios from "axios";
import i18n from "../../i18n";

const EventsList = ({ events, registered, person, api, code }) => {
    // const [blocks, setBlocks] = useState({});
    const [checked, setChecked] = useState([]);
    const [starterSelections, setStarterSelections] = useState({});
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [chosen, setChosen] = useState(null);
    const [regEntries, setRegEntries] = useState([]);

    const { t } = i18n;
    const hasCode = code !== undefined && code !== null && code !== "";

    const handleClickOpen = (event) => {
        setChosen(event.currentTarget.getAttribute("uuid"));
        setOpen(true);
    };

    const handleClose = () => {
        setChosen(null);
        setOpen(false);
    };

    const navigate = useNavigate();
    useEffect(() => {
        setRegEntries(registered);
    }, []);
    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const handleStarterChange = (eventId, starterId) => {
        setStarterSelections((prev) => ({ ...prev, [eventId]: starterId }));
        setChecked((prev) => {
            const has = prev.indexOf(eventId) !== -1;
            if (starterId && !has) {
                return [...prev, eventId];
            }
            if (!starterId && has) {
                return prev.filter((id) => id !== eventId);
            }
            return prev;
        });
    };

    const registerToEvents = () => {
        setLoading(true);

        axios
            .put(`${api.registerToEventsAnonymously}${person.personId}`, { chosen: checked, starters: starterSelections, events: events, locale: i18n.language, code: code })
            .then(function (response) {
                // console.log(response.data);
                navigate("/validation", { state: { entries: response.data.entries, rejected: response.data.rejected } });
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };
    const removeFromEvent = () => {
        setLoading(true);
        axios
            .put(`${api.removeFromEventAnonymously}${chosen}`, { locale: i18n.language })
            .then(function (response) {
                // tmpUuid = response.data.uuid;
                setRegEntries(response.data);
                setChosen(null);
                setOpen(false);
                setLoading(false);
            })
            .catch(function (error) {
                console.log(error);
                setLoading(false);
            });
    };
    return (
        <Box>
            <Stack spacing={1}>
                {events.length === 0 && <Alert severity="warning">{t("reg.no_categories_found")}</Alert>}

                <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                        {/* <Typography variant="h5" component="div">
                            {b.name}
                        </Typography> */}
                        <List>
                            {events.map((c) => {
                                return (
                                    <React.Fragment key={`d-${c.id}`}>
                                        {regEntries?.filter((e) => e.event.id === c.id).length > 0 && (
                                            <ListItem
                                                secondaryAction={
                                                    <Tooltip title={t("reg.remove")}>
                                                        <IconButton
                                                            edge="end"
                                                            aria-label="delete"
                                                            cid={c.id}
                                                            uuid={regEntries.filter((e) => e.event.id === c.id)[0].uuid}
                                                            onClick={handleClickOpen}
                                                        >
                                                            <DeleteIcon sx={{ color: red[500] }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                }
                                            >
                                                <ListItemIcon>
                                                    <CheckBoxIcon sx={{ color: green[500] }} />
                                                </ListItemIcon>
                                                <ListItemText id={`cat-lab-${c.id}`} primary={c.name} secondary={t("reg.already_registered")} />
                                            </ListItem>
                                        )}
                                        {regEntries?.filter((e) => e.event.id === c.id).length === 0 && (
                                            <ListItem disablePadding>
                                                {(c.registration?.open || hasCode) && c.registrationType === "starter" && (
                                                    <>
                                                        {c.eligibleStarters && c.eligibleStarters.length > 0 ? (
                                                            <Box sx={{ width: "100%", px: 2, py: 1 }}>
                                                                <FormControl fullWidth size="small">
                                                                    <InputLabel id={`starter-lab-${c.id}`}>{c.name}</InputLabel>
                                                                    <Select
                                                                        labelId={`starter-lab-${c.id}`}
                                                                        value={starterSelections[c.id] || ""}
                                                                        label={c.name}
                                                                        onChange={(e) => handleStarterChange(c.id, e.target.value)}
                                                                    >
                                                                        <MenuItem value="">
                                                                            <em>{t("reg.choose_starter")}</em>
                                                                        </MenuItem>
                                                                        {c.eligibleStarters.map((s) => (
                                                                            <MenuItem key={s.id} value={s.id}>
                                                                                {s.name}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </FormControl>
                                                            </Box>
                                                        ) : (
                                                            <>
                                                                <ListItemIcon>
                                                                    <DoDisturbOnIcon sx={{ color: red[500] }} />
                                                                </ListItemIcon>
                                                                <ListItemText id={`cat-lab-${c.id}`} primary={c.name} secondary={t("reg.no_eligible_starters")} />
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                                {(c.registration?.open || hasCode) && c.registrationType !== "starter" && (
                                                    <ListItemButton role={undefined} onClick={handleToggle(c.id)} dense>
                                                        <ListItemIcon>
                                                            <Checkbox
                                                                edge="start"
                                                                checked={checked.indexOf(c.id) !== -1}
                                                                tabIndex={-1}
                                                                disableRipple
                                                                inputProps={{ "aria-labelledby": `cat-lab-${c.id}` }}
                                                            />
                                                        </ListItemIcon>
                                                        <ListItemText id={`cat-lab-${c.id}`} primary={c.name} secondary={c.payment} />
                                                    </ListItemButton>
                                                )}
                                                {c.registration?.open === false && !hasCode && (
                                                    <>
                                                        <ListItemIcon>
                                                            <DoDisturbOnIcon sx={{ color: red[500] }} />
                                                        </ListItemIcon>
                                                        <ListItemText id={`cat-lab-${c.id}`} primary={c.name} secondary={t("reg.status.reason.reg_open")} />
                                                    </>
                                                )}
                                            </ListItem>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </List>
                    </CardContent>
                </Card>

                {loading && <LinearProgress />}
                <Button
                    variant="contained"
                    color="success"
                    size="large"
                    onClick={registerToEvents}
                    disabled={checked.length === 0 || loading}
                    startIcon={<GroupAddIcon />}
                    fullWidth
                >
                    {t("reg.register")}
                </Button>
            </Stack>
            <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title" className="text-start">
                    {t("reg.remove_title")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className="text-start" id="alert-dialog-description">
                        {t("reg.info.remove")}
                    </DialogContentText>
                    {loading && <LinearProgress />}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        {t("back")}
                    </Button>
                    <Button disabled={loading} color="error" onClick={removeFromEvent}>
                        {t("reg.remove")}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default EventsList;
